"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var _colors = require("HubStyleTokens/colors");

var _ChecklistItem = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ChecklistItem"));

var ModalBodyContainer = _styledComponents.default.div.withConfig({
  displayName: "FeaturesModal__ModalBodyContainer",
  componentId: "kue60i-0"
})(["padding:40px;"]);

var ModalHeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "FeaturesModal__ModalHeaderContainer",
  componentId: "kue60i-1"
})(["background-color:", ";height:70px;width:100%;border-bottom:1px solid ", ";display:flex;align-items:center;padding-left:40px;padding-right:20px;"], _colors.GYPSUM, _colors.KOALA);

var ModalHeader = _styledComponents.default.div.withConfig({
  displayName: "FeaturesModal__ModalHeader",
  componentId: "kue60i-2"
})(["flex-grow:1;font-size:20px;font-weight:600;"]);

var FeaturesModal = function FeaturesModal(_ref) {
  var header = _ref.header,
      features = _ref.features,
      onModalClose = _ref.onModalClose,
      hubType = _ref.hubType;
  return _react.default.createElement(_UIModal.default, null, _react.default.createElement(ModalHeaderContainer, null, _react.default.createElement(ModalHeader, null, header), _react.default.createElement(_UICloseButton.default, {
    color: _colors.OBSIDIAN,
    onClick: onModalClose
  })), _react.default.createElement(ModalBodyContainer, null, Object.keys(features).map(function (feature) {
    return _react.default.createElement(_ChecklistItem.default, {
      key: feature,
      tooltipMessage: (0, _getFeatureDescriptionKey.default)(feature, hubType),
      message: "pricing-pages.features." + feature + ".name",
      className: "m-bottom-5",
      fontSize: 16
    });
  })));
};

var _default = FeaturesModal;
exports.default = _default;
module.exports = exports.default;